import * as ko from 'knockout';
import {ICompany, IMessageData} from '../../index';
import {global, lm} from '../../appContext';
import {SNACKBAR_DURATION_MEDIUM} from '../../constants';
import {ERROR_MESSAGE, PLEASE_WAIT_MESSAGE} from '../../constants/Language';
import {getRouteDropdownButton} from '../../constants/RouteDefinitions';
import {IPageShellHeaderActions} from '../page-shell/pageShellHeaderActions';
import {nsFa} from '../fa/fn';
import i = nsFa.i;

/**
 * Customer setup actions for the page heading:
 * create/edit up front; note, cache, password reset and delete behind "Mer".
 */
export function buildCustomerSetupActions(company: ICompany): IPageShellHeaderActions {
    return {
        quick: [getRouteDropdownButton('editcustomer', {label: 'edit'})],
        more: [
            {
                icon: 'fa-empty-be-cache',
                label: 'empty server cache',
                onClick: () => emptyServerCache(company),
                validator: () => global.permissionValidator.superAdmin(),
            },
            {
                icon: 'fa-lock-undo',
                label: 'Restore initial password for all users',
                onClick: () => global.dialogManager.addComponent({
                    content: {
                        name: 'component/customer/dialog/restore-first-time-passwords',
                        params: {},
                    },
                    title: 'Restore initial password for all users',
                }),
                validator: () => global.permissionValidator.isMinCompanyAdmin(),
            },
            {
                cls: 'btn-separated btn-destructive explicit',
                icon: 'fa-trash-alt',
                label: 'delete',
                onClick: () => global.dialogManager.addComponent({
                    content: {
                        name: 'component/customer/dialog/delete.customer',
                        params: {},
                    },
                    fullWidth: false,
                    title: `((delete)) [${company.name}]`,
                }),
            },
            // Separator + last item in "Mer" menu.
            getRouteDropdownButton('createcustomer', {cls: 'btn-action btn-separated'}),
        ],
    };
}

function emptyServerCache(company: ICompany): void {
    const messageData = ko.observable<IMessageData | null>(null);
    global.dialogData({
        title: `${i('fa-recycle')} ((empty server cache))`,
        body: `<p>${lm.t(`message: empty server cache|name:${company.name}`)}</p><p>((do you wish to continue))</p>`,
        confirmLabel: 'yes, continue',
        cancelLabel: 'no, cancel',
        onConfirm: () => {
            global.reqServiceFactory({
                serviceName: 'emptycache',
                messageData,
                requestMessage: PLEASE_WAIT_MESSAGE,
                errorMessage: ERROR_MESSAGE,
                errorCallback: () => global.snackbarData(messageData()),
                successCallback: () => {
                    global.snackbarData({
                        message: 'cache is emptied',
                        duration: SNACKBAR_DURATION_MEDIUM,
                    });
                    global.cacheManager.removeCache();
                },
            }).request();
        },
    });
}
